const convertBase64ToFile = (binaryData, mimeType, fileName) => {
    const byteNumbers = new Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
        byteNumbers[i] = binaryData.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: mimeType});

    return new File([blob], fileName, {type: mimeType});
};


export const getTxtContentByPath = async (filePath) => {
    const fileName =  filePath.split('/').pop().split('\\').pop();
    const fileExtension = fileName.split('.').pop().toLowerCase();
    const res = await window.electronAPI.getTxtContent(filePath);
    return res
};


export const getFileObjByPath = async (filePath) => {
    const fileName =  filePath.split('/').pop().split('\\').pop();
    const fileExtension = fileName.split('.').pop().toLowerCase();
    const uint8Array = await window.electronAPI.getFileBinary(filePath);

    let fileRes
    if (['txt', 'json', 'html', 'js', 'css'].includes(fileExtension)) {
        const textDecoder = new TextDecoder('utf-8');
        fileRes = textDecoder.decode(uint8Array);
    } else {
        const blob = new Blob([uint8Array], { type: fileExtension});
        fileRes = new File([blob], fileName, { type: fileExtension})
    }

    return fileRes
};

export const getFileUTF8ContentByPath = async (filePath) => {
    const uint8Array = await window.electronAPI.getFileBinary(filePath);
    const textDecoder = new TextDecoder('utf-8');
    return textDecoder.decode(uint8Array);
};

